import ImageIcon from "@redotech/redo-icons/image-01.svg";
import { ImageElement } from "@redotech/redo-model/content-builder/element-schema";
import { memo } from "react";
import { Flex } from "../../flex";
import * as ImageCSS from "./form-image.module.css";

export const FormImage = memo(function FormImage({
  element,
}: {
  element: ImageElement;
}) {
  return (
    <Flex w="full">
      {element.url !== "" ? (
        <img src={element.url} />
      ) : (
        <div className={ImageCSS.placeholder}>
          <ImageIcon />
          Add image
        </div>
      )}
    </Flex>
  );
});
